import { loadConfig, WorkspaceAuthProvider } from "@procurement-agents/auth";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";

loadConfig().then((config) => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <WorkspaceAuthProvider config={config}>
        <BrowserRouter><App /></BrowserRouter>
      </WorkspaceAuthProvider>
    </StrictMode>,
  );
}).catch((e) => { document.getElementById("root")!.textContent = `Workspace unavailable: ${e}`; });
